export default "__VITE_ASSET__CMQvWb09__"